import { render, staticRenderFns } from "./GraduaShop.vue?vue&type=template&id=01363faa&scoped=true"
import script from "./GraduaShop.vue?vue&type=script&lang=js"
export * from "./GraduaShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01363faa",
  null
  
)

export default component.exports